module.exports = function() {
  return new Worker("/" + "pug-transpiler.41006669.worker.js");
};